import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType } from '@checkmarx/cx-ui';
import PortalTextBox from '../../../portal/portalTextBox';
import TextfieldFloatingText from '../../../portal/textfieldFloatingText';
import ErrorDialog from '../../../portal/dialogs/errorDialog';
import ToastrLevelsEnum from '../../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../../services/ui/toastrService';
import { buildDataStructure } from '../../../../services/permissions';
import PermissionItemContainer from '../permissionsItem';
import styles from './style.scss';
import { Redirect } from 'react-router-dom';

@inject('translationsStore', 'rolesStore') @observer
export default class EditRoleFormContainer extends Component {
  
    t = this.props.translationsStore;
    rolesStore = this.props.rolesStore;
    operationErrorMessage = '';

    state = {
        showErrorDialog: false,
        permissionsData: [],
        backToRolesScreen: false,
    }

    componentDidMount() {

        this.buildPermissions();
    }

    buildPermissions = _ => {

        let permissionsData = 
            buildDataStructure(this.props.authenticationProviders, this.props.permissions);
        
        if(permissionsData.length > 0) {

            this.setState({
                permissionsData: permissionsData
            });
        }
    }

    handleNameChange = e => this.rolesStore.setName(e.target.value);
    handleNameOnBlur = e => this.rolesStore.setName(e.target.value);

    handleDescriptionChange = e => this.rolesStore.setDescription(e.target.value);
    handledeDcriptionOnBlur = e => this.rolesStore.setDescription(e.target.value);

    openErrorDialog = () => {

        this.setState({ 
            showErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            showErrorDialog: false
        }); 
    }

    triggerToastr = (message, level) => ToastrService.triggerToastr({level, message});

    updateRole = _ => {

        const role = {
            name: this.rolesStore.name,
            description: this.rolesStore.description,
            permissionIds: this.rolesStore.permissionIds
        }
        
        const saveRole = this.props.id > 0 ? this.rolesStore.updateRole(this.props.id, role) : this.rolesStore.createRole(role);
        
        saveRole.then(_ => {

            this.rolesStore.getRole(this.props.id);

            const level = ToastrLevelsEnum.SUCCESS;
            const message = this.t.translate(this.getSuccessMessageKey());
            this.setState({ 
                backToRolesScreen: true
            });
            this.triggerToastr(message, level);
        })
        .catch(err => {

            this.openErrorDialog();
        })
    }

    getSuccessMessageKey = () => {
        return this.props.id > 0 ? 'ROLE_UPDATED_SUCCESS_MESSAGE' : 'ROLE_CREATED_SUCCESS_MESSAGE';
    }

    saveRole = e => {

        e.preventDefault();
        
        if (true) {
            
            this.updateRole();
        }
    }

    render() {
        
        if(this.state.backToRolesScreen === true) {
            
            return <Redirect to='/roles' />;
        }

        return (
            <form
                onSubmit={this.saveRole}
            >
                <div
                    className={styles.editRoleFormWrapper}
                >
                    <div>
                        <PortalTextBox
                            hintText={this.t.translate('ROLE_NAME')}
                            floatingLabelText={<TextfieldFloatingText title={this.t.translate('ROLE_NAME')} required={true} />}
                            disabled={this.rolesStore.updateRoleInProgress}
                            onChange={this.handleNameChange}
                            onBlur={this.handleNameOnBlur}
                            errorText={this.operationErrorMessage}
                            width='50%'
                            value={this.rolesStore.name}
                            />
                    </div>
                    <div>
                        <PortalTextBox
                            hintText={this.t.translate('DESCRIPTION')}
                            floatingLabelText={<TextfieldFloatingText title={this.t.translate('DESCRIPTION')} required={true} />}
                            disabled={this.rolesStore.updateRoleInProgress}
                            onChange={this.handleDescriptionChange}
                            onBlur={this.handledeDcriptionOnBlur}
                            errorText={this.operationErrorMessage}
                            width='100%'
                            value={this.rolesStore.description}
                        />
                    </div>
                    <PermissionItemContainer
                        data={this.state.permissionsData}
                    />
                </div>
                <div
                    className={styles.editRoleButtonsContainer}
                >
                    <span
                        className='portal-blank-button'
                        onClick={this.props.cancelHandler}
                        style={{marginRight: 30}}
                    >
                        {this.t.translate('CANCEL')}
                    </span>
                    <Button
                        type='submit'
                        onClick={this.saveRole}
                        text={this.t.translate('SAVE')}
                        inProgress={this.rolesStore.updateRoleInProgress}
                    />
                </div>
                <ErrorDialog 
                    show={this.state.showErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.t.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.t.translate('ERROR')}
                    contentText={this.props.rolesStore.updateRoleErrorMessage}
                />
            </form>
        );
    }
}